<template lang='pug'>
  UsersBisnisUnitList(:title='title')
</template>

<script>
import UsersBisnisUnitList from "../components/UsersBisnisUnitList.vue";
export default {
  name: "Details User",
  components: {
    UsersBisnisUnitList
  },
  data: () => ({
    title: "Details Account"
  }),
};
</script>
